module.exports = __webpack_public_path__ + "static/media/vspace-sky.4415fe07.png";